import React from "react";
import { DashboardStatCard } from "./UI";
import {
  AlertTriangle,
  CheckCircle2,
  ClipboardList,
  Layers,
  XCircle,
} from "lucide-react";

export function buildFormQuestionStats(meta) {
  const usingDefaults = Boolean(meta?.using_defaults);
  const total = usingDefaults
    ? (meta?.default_count ?? 0)
    : (meta?.active_count ?? 0) + (meta?.inactive_count ?? 0);
  return {
    total,
    totalSub: usingDefaults ? "platform defaults" : "custom questions",
    active: meta?.active_count ?? 0,
    inactive: meta?.inactive_count ?? 0,
    required: meta?.required_count ?? 0,
    groups: meta?.sections_count ?? meta?.categories_count ?? 0,
  };
}

export default function FormQuestionsStatGrid({ meta, loading = false, groupLabel = "Sections", onCardClick, activeKey }) {
  const s = buildFormQuestionStats(meta);
  const groupSub = groupLabel === "Categories" ? "unique categories" : "unique sections";

  const cards = [
    {
      key: "total",
      label: "Total Questions",
      value: s.total,
      sub: s.totalSub,
      icon: ClipboardList,
      color: "blue",
    },
    {
      key: "active",
      label: "Active",
      value: s.active,
      sub: "currently enabled",
      icon: CheckCircle2,
      color: "emerald",
    },
    {
      key: "inactive",
      label: "Inactive",
      value: s.inactive,
      sub: "disabled questions",
      icon: XCircle,
      color: "slate",
    },
    {
      key: "required",
      label: "Required",
      value: s.required,
      sub: "must be answered",
      icon: AlertTriangle,
      color: "red",
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {cards.map((c) => (
        <DashboardStatCard
          key={c.label}
          {...c}
          loading={loading}
          onClick={onCardClick ? () => onCardClick(c.key) : undefined}
          active={activeKey === c.key}
        />
      ))}
    </div>
  );
}
